export const pipLocators = {
  container: 'Pip-Container',
  statusBar: 'Pip-StatusBar',
  statusToggle: 'Pip-StatusToggle',
  statusDropdown: 'Pip-StatusDropdown',
  statusOption: 'Pip-StatusOption',
  callControls: 'Pip-CallControls',
  callInfo: 'Pip-CallInfo',
  muteButton: 'Pip-MuteButton',
  holdButton: 'Pip-HoldButton',
  recordButton: 'Pip-RecordButton',
  hangupButton: 'Pip-HangupButton',
  duration: 'Pip-Duration',
  incomingCall: 'Pip-IncomingCall',
  acceptButton: 'Pip-AcceptButton',
  declineButton: 'Pip-DeclineButton',
};
